





















import { Component, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import AppHeader from "@/views/AppHeader.vue";

import UserServiceApi, {
  UserServiceGateway,
  Service,
  ServiceId
} from "@/api/gateways/user-service-api";
import ServiceOptionDecorator from "@/decorators/service-option-decorator";

@Component({
  components: {
    AppHeader
  }
})
export default class SelectService extends Vue {
  id = "";

  get options(): SelectOption[] {
    return this.services.map(ServiceOptionDecorator);
  }

  created() {
    this.id = String(this.$store.state.service.id || "");
    this.initServiceList();
  }

  async submit() {
    if (!this.id) return;
    const id = Number(this.id);
    await this.loginService(id);
    await this.setService(id);
    this.$router.push("/");
  }

  private services: Service[] = [];

  private get serviceApi(): UserServiceGateway {
    return new UserServiceApi(this.$store.getters.api);
  }

  private async initServiceList() {
    const services = await this.serviceApi.all();
    this.services = services.filter(service => !service.disabled);
  }

  private async loginService(id: ServiceId) {
    const token = await this.serviceApi.login(id);
    this.$store.commit("token", token);
  }

  private async setService(serviceId: ServiceId) {
    await this.$store.dispatch("initService", { serviceId });
  }
}
